<template>
  <div class="min-h-dvh flex flex-col">
    <div :class="['flex-1 px-3 relative', isRaw ? 'py-3' : 'pt-20', 'pb-7']">
      <div v-if="!isRaw" class="bg-page absolute w-full h-dvh -z-10 left-0"></div>
      <router-view></router-view>
      <slot></slot>
    </div>
    <div v-if="!isRaw" class="container flex flex-col items-center justify-center pt-10 pb-10 mx-auto">
      <div class="text-xs">{{ poweredByString }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalConfigStore } from "@/features/Shared/stores";
import { useTranslation } from "i18next-vue";

// Variables
const { t } = useTranslation();
const { isRaw } = useGlobalConfigStore();

// Strings
const poweredByString = t("commons.powered_by", { version: "2025.1.101" });
</script>
